import { OrderCreatePage } from '@apps-common/apps/portal/pages/orders/pages/create/Index'

export const OrderCreate = () => <OrderCreatePage />
